import React from "react";
import { default as WDialogContent } from "@mui/material/DialogContent";

function DialogContent(props) {
  return <WDialogContent {...props} />;
}

export default DialogContent;
